import React from "react";
import { Helmet } from "react-helmet-async";

function OnlineSessions() { 
    return(
        <section class="py-md-3 py-sm-3 py-3" id="online-sessions">
            <Helmet>
                <title>Online Sessions | Adya Yoga</title>
                <meta
                  name="description"
                  content="Join online for Yoga, Meditation, Energy Reading, Chakra Balancing, Reiki, Animal Communication and more."
                />
                <link rel="canonical" href="https://yogaadya.com/online-sessions" />
                <meta name="robots" content="index, follow" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Adya Yoga" />
                <meta property="og:title" content="Online Sessions | Adya Yoga" />
                <meta property="og:description" content="Book online sessions for yoga, meditation and energy therapies." />
                <meta property="og:url" content="https://yogaadya.com/online-sessions" />
                <meta property="og:image" content="https://yogaadya.com/assets/images/online_seesion01.webp" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Online Sessions | Adya Yoga" />
                <meta name="twitter:description" content="Join online for yoga, meditation and energy therapies." />
                <meta name="twitter:image" content="https://yogaadya.com/assets/images/online_seesion01.webp" />
            </Helmet>
            <div className="events-retreats-container">
                <div className="events-header">
                    <h1 className="events-title">Online Sessions</h1>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <img src="assets/images/online_seesion01.webp" alt="Online Sessions" class="img-fluid"></img>
                    </div>
                </div>

                <br/>

                <div class="row">
                    <div class="col-lg-7 col-md-7">
                        <div className="about-two-grids">
                            <div className="about-para-txt">
                                <p>As we all know Energy isn’t bound by time or space. Many of us can’t make it to a personal Yoga Session, Energy Reading or a Healing Therapy due to lack of time or distance issues. Energy and Learning has a possibility to be transmitted over any distance. So, in case you are willing to do some good to your body, mind and soul, we can work together on it through Online Sessions.</p>

                                <p><b>Online Sessions:-</b></p>
                                <p>Yoga and Meditation Lessons</p>
                                <p>Energy Reading/ Aura Scan</p>
                                <p>Energy Coaching</p>
                                <p>Chakra Balancing</p>
                                <p>Reiki</p>
                                <p>Animal Communication</p>
                                <p>Flower Essence Consultation</p>

                                <br/>
                                <p>You can even book a combination of lessons and therapies to address your overall well‑being.</p>
                                <p><b>Combo 1:-</b> Energy Reading+ Yoga and Meditation Lessons+ Energy Coaching. (5 Sessions)</p>
                                <p><b>Combo 2:-</b> Energy Reading+ Chakra Balancing+ Energy Coaching. (3 Sessions)</p>
                                <p><b>Combo 3:-</b> Energy Reading+ Reiki+ Energy Coaching. (3 Sessions)</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-5 col-md-5">
                        <div className="about-two-grids">
                            <div className="about-para-txt">
                                <p>My best suggestion would be to start with booking yourself a combo session and then further pick what suits you best and continue.</p>
                                <p>We use technology for our best. All sessions are done through Zoom, WhatsApp, Calling and Emails.</p>
                                <p>Write in to me in case of any doubts.</p>
                                <a href="/contact" className="register-btn">Book Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default OnlineSessions;